import { trace } from 'rytm-helpers'

const BOTTOM_SHAPES_FALLBACK = 1000


export const updateWfBackground = () => {
  const wrapper = document.querySelector(".box-bg-shapes")
  if (wrapper) {
    if (wrapper.offsetHeight > BOTTOM_SHAPES_FALLBACK && wrapper.offsetHeight > wrapper.offsetWidth * .7) {
      wrapper.classList.add("bottom-shapes")
    } else {
      wrapper.classList.remove("bottom-shapes")
    }
  }
}
